import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { I18nService } from '@app/core/i18n.service';
import { environment } from '@env/environment';
import { BaseAPIService } from '@app/Services/api.base.service';
import { label } from '@app/constants/labels';
import { rolesdef } from '@app/constants/role-def';
import { MapService } from '@app/map/map.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  menuHidden = true;

  public seLogo: string;

  public title: string;
  public subtitle: string;
  public user: any = {};
  public logo: string;
  public ecoLogo: string;
  public loginIcon: string;
  public dropIcon: string;
  public localeIcon: string;
  public language: string;

  public isLoggedIn: boolean = false;
  public isInternalUser: boolean = true; // default isInternalUser is true
  public loggedInUser: string | null;
  public urls: any = {};
  labels: any;
  roleCd: string;
  roles: any;

  constructor(private readonly baseService: BaseAPIService, public router: Router,
    private readonly authenticationService: AuthenticationService,
    private i18nService: I18nService, private readonly mapService: MapService) { }

  ngOnInit() {
    this.labels = label;
    this.roles = rolesdef;
    this.dropIcon = 'assets/dropdown.svg';
    this.localeIcon = 'assets/countrySelection.svg';
    this.loginIcon = 'assets/login.svg';
    this.logo = 'assets/speedometer.svg';
    this.ecoLogo = 'assets/eco-cc-logo.png';
    this.seLogo = 'assets/schneiderLogo.png';
 
    this.title = environment.title;
    this.roleCd = this.authenticationService.authenticatedRoleCd;

    this.isLoggedIn = this.authenticationService.isAuthenticated();
    this.loggedInUser = this.isLoggedIn ? this.authenticationService.authenticatedUser : "";
    this.isInternalUser = this.authenticationService.context && JSON.parse(JSON.stringify(this.authenticationService.context.idms)).isInternal !== null ? JSON.parse(JSON.stringify(this.authenticationService.context.idms)).isInternal.toLowerCase() === 'true' : false;
     this.urls = JSON.parse(this.authenticationService.urls);

    this.language = localStorage.getItem('language');
  }

  toggleMenu() {
    this.menuHidden = !this.menuHidden;
  }

  setLanguage(language: any) {
    this.i18nService.language = language.code;

  }

  logout() {
    this.authenticationService.logout();
  }

  get currentLanguage(): string {

    const sslang = this.i18nService.supportedLanguages.filter(item => item.code === this.i18nService.language);
    return sslang[0].name;
  }

  get languages(): any[] {
    return this.i18nService.supportedLanguages;
  }



}
